import { render, staticRenderFns } from "./RelatedPersons.vue?vue&type=template&id=080ac581&"
import script from "./RelatedPersons.vue?vue&type=script&lang=js&"
export * from "./RelatedPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports